import React from "react";
import styled from "styled-components";


export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
      <FooterWrapper>
        <div className="darkBg">
          <div className="container">
            <InnerWrapper className="flexSpaceCenter" >
              {/*<div className="flexCenter animate">*/}
              {/*  <Img className="radius8" src={LogoIcon} alt="logo" />*/}
              {/*  <h1 className="font15 extraBold whiteColor" style={{ marginLeft: "15px" }}>*/}
              {/*    Teppich Hosseinzadeh*/}
              {/*  </h1>*/}
              {/*</div>*/}
              <StyleP className="whiteColor font13">
                © {getCurrentYear()} - <span className="purpleColor font13">Teppichhaus Hosseinzadeh</span>
              </StyleP>
              <Kontakt>
                <div className="whiteColor animate font13">
                  <p className="font10"><strong>Adresse:</strong> Sindelfinger Str. 11, 71032 Böblingen</p>
                  <p className="font10"><strong>Telefon:</strong> 07031-224724</p>
                  <p className="font10"><strong>E-Mail:</strong> orient-hosseinzadeh@live.de</p>
                  <p className="font10"><strong>Öffnungszeiten:</strong> Mo–Fr 10:00–18:00 · Sa 9:00–14:00</p>
                </div>
              </Kontakt>
              <Kontakt>
                <div className="whiteColor animate font13">
                  <p className="font10"><strong>Impressum:</strong> Teppichhaus Hosseinzadeh, Inhaber: Ismaeil Hosseinzadeh<br />
                    Verantwortlich gem. § 5 TMG: Ismaeil Hosseinzadeh<br />
                    Hinweis: Diese Website erhebt keine personenbezogenen Daten.</p>
                </div>
              </Kontakt>


            </InnerWrapper>
          </div>
        </div>
      </FooterWrapper>
  );
}


const FooterWrapper = styled.div`
  //margin-top: auto; /* Ensures footer sticks to the bottom */
  width: 100%;
  position: relative;
  bottom: 0;
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px 0 10px 0;

  @media (max-width: 350px) {
    flex-direction: column;
    text-align: center;
  }
`;

const StyleP = styled.p`
  @media (max-width: 350px) {
    margin: 2px 0;
  }
`;


const Kontakt = styled.div`
  display: flex;
  z-index: 9;
  color: white;
  gap: 10px;
`;
